import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container app-container" }

import { ref, onMounted } from 'vue'
import { useGettext } from 'vue3-gettext'
import ImpersonateNotification from '@/components/CommonUI/ImpersonateNotification.vue'
import LoaderErrorBlock from '@/components/CommonUI/LoaderErrorBlock.vue'
import NavBar from '@/components/NavBar.vue'
import { useUserStore } from '@/store/user'
import { getErrorMessage } from '@/helpers/errors'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { $gettext } = useGettext()
const { getJwtUser, getUserSubscription } = useUserStore()

const dashboardUrl = process.env.VUE_APP_DASHBOARD_URL || 'https://dashboard.dittomusic.com'
const isLoaded = ref(false)
const errorMessage = ref('')

onMounted(async () => {
  try {
    await getJwtUser()
  } catch (error) {
    window.location.replace(`${dashboardUrl}/login`)
  }
  try {
    await getUserSubscription()
    isLoaded.value = true
  } catch (error) {
    errorMessage.value = getErrorMessage(error)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavBar),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(ImpersonateNotification),
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(LoaderErrorBlock, {
            key: 0,
            "error-title": _unref($gettext)('Oops! We couldn’t load this right now.'),
            "error-message": errorMessage.value.length ? _unref($gettext)('Please refresh the page or try again later.') : '',
            class: "row no-space justify-center"
          }, null, 8, ["error-title", "error-message"]))
        : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
    ])
  ], 64))
}
}

})